module.exports = __webpack_public_path__ + "static/media/material_master.6d6006f0.csv";